import { render } from "./HeroOrbit.vue?vue&type=template&id=55aef963&scoped=true"
import script from "./HeroOrbit.vue?vue&type=script&lang=js"
export * from "./HeroOrbit.vue?vue&type=script&lang=js"

import "./HeroOrbit.vue?vue&type=style&index=0&id=55aef963&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aef963"]])

export default __exports__